import { version } from '../../package.json';
export default version;
//# sourceMappingURL=index.js.map
